exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.calculate-discont-hide {\n  display: none;\n}\n.format {\n    margin-left: 5px;\n}\n", ""]);

// exports
